module.exports = __webpack_public_path__ + "static/img/tigongchanye.ca98150.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/custom/tigongchanye.png
// module id = +YYH
// module chunks = 1